module.exports = __webpack_public_path__ + "static/media/19ESCAP2.2b4941c1.jpg";